import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M12 21.999C17.5229 21.999 22 17.5219 22 11.999C22 6.47617 17.5229 1.99902 12 1.99902C6.47715 1.99902 2 6.47617 2 11.999C2 17.5219 6.47715 21.999 12 21.999Z",
      stroke: "white",
      "stroke-width": "2",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M9.5 9V15",
      stroke: "white",
      "stroke-width": "2",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M14.5 9V15",
      stroke: "white",
      "stroke-width": "2",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }